import styled from "styled-components";
import { Field } from "redux-form/immutable";
import { useIntl } from "react-intl";

import { creatable } from "../../up-styled-creatable";
import { selectBox } from "../../select-box";
import UpRegex from "../../up-regex";
import FormValueSelector from "../../up-form-value-selector";

import {
  getOptions,
  type ConditionOperator,
  type ConditionProduct,
  type ResettableConditionFilterProps
} from "../utils";

const Filter = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    align-items: stretch;
  }
  @media only screen and (max-width: 550px) {
    flex-direction: column;
    align-items: stretch;
    width: auto;
  }
`;

const Row = styled.div`
  margin-bottom: 0px;
  display: flex;
  flex: 1 1 auto;
  @media only screen and (max-width: 800px) {
    margin-bottom: 10px;
  }
`;

interface ReferrerProps extends ResettableConditionFilterProps {
  product: ConditionProduct;
}

const Referrer = ({ member, product, resetOnChange }: ReferrerProps) => {
  const defaultOptions = [
    "contains",
    "contains-not"
  ] satisfies readonly ConditionOperator[];
  const intl = useIntl();

  const optionsByProduct: Partial<
    Record<ConditionProduct, readonly ConditionOperator[]>
  > = {
    mail: ["regex"]
  };

  return (
    <Filter>
      <Row>
        <Field
          name={`${member}.filter.operator`}
          component={selectBox}
          customProps={{
            options: getOptions(optionsByProduct[product], defaultOptions).map(
              ({ value, label }) => ({
                value,
                label: intl.formatMessage(label),
              }),
            ),
            minWidth: '250px',
            margin: '0 10px 0 0',
            onChange: () => resetOnChange()
          }}
        />
      </Row>
      <FormValueSelector
        fieldName={`conditions[${member
          .split("[")[1]
          .charAt(0)}]filter.operator`}
      >
        {(operator) => {
          if (operator === "regex") {
            return (
              <UpRegex
                name={`${member}.filter.attribute[0].value`}
                margin="0 10px 0 0"
                width="100%"
                fieldValidation={false}
              />
            );
          }

          return (
            <Field name={`${member}.filter.attribute`} component={creatable} />
          );
        }}
      </FormValueSelector>
    </Filter>
  );
};

export default Referrer;
